<template>
  <div class="cvs-on-line-item" v-if="data.resume && data.resume.info" @click="$emit('click')">
    <div class="picture" :style="{backgroundImage: `url(${data.resume.info.profile.avatar_url || 'https://photo.wondercv.com/cv_doc@2x.png'})`}">
      <!-- <img class="img1" v-if="data.resume.info.profile.avatar_url" :src="data.resume.info.profile.avatar_url" alt=""> -->
      <!-- <img class="img2" v-else src="https://photo.wondercv.com/cv_doc@2x.png"> -->
      <div class="tip" @click.stop v-if="!showOnlineCvTips && new Date(data.resume.updated_at).getTime() < new Date('2020-4-8').getTime()">
        <div class="tip-close" @click.stop="closeTip"></div>
        <img src="https://files.wondercv.com/cvsvue/cvstip.png" alt="">
      </div>
    </div>
    <div class="info">
      <div class="info-name text-overflow">{{data.resume.info.profile.username}}</div>
      <div class="info-type" v-if="is_student && data.resume.info && data.resume.info.education_experiences && data.resume.info.education_experiences.length">
        <span>{{data.resume.info.education_experiences[0].cust_uni_name || data.resume.info.education_experiences[0].school.cn}}</span>
        <span> | </span>
        <span>{{data.resume.info.education_experiences[0].cust_degree || data.resume.info.education_experiences[0].degree_name.cn}}</span>
      </div>
      <div class="info-type" v-if="!is_student && data.resume.info && ((data.resume.info.work_experiences && data.resume.info.work_experiences.length) || (data.resume.info.internship_experiences.length))">
        {{(data.resume.info.work_experiences[0] || data.resume.info.internship_experiences[0]) | workTitleFilter }}
      </div>
      <div class="info-date">{{moment(data.resume.updated_at).format('YYYY年MM月DD日 HH:mm')}} 更新</div>
      <div class="btn">
<!--        <button v-if="isPerfect" @click.stop="$emit('perfect')">更新</button>-->
        <button v-if="isUpdated || isPerfect" @click.stop="$emit('updated')">更新</button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'CvsUpLineItem',
  props: ['data', 'isUpdated', 'is_student', 'isPerfect'],
  data() {
    return {
      moment,
      showOnlineCvTips: false
    };
  },
  created() {
    this.showOnlineCvTips = !!JSON.parse(localStorage.getItem('showOnlineCvTips'));
    localStorage.setItem('showOnlineCvTips', JSON.stringify(true));
  },
  methods: {
    closeTip() {
      this.showOnlineCvTips = true;
      localStorage.setItem('showOnlineCvTips', JSON.stringify(true));
    }
  },
  filters: {
    workTitleFilter(val) {
      if (!val) return
      return val.title
    }
  }
}
</script>
<style lang="scss" scoped>
.cvs-on-line-item {
  height: 124px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 32px;
  background: #fff;
  position: relative;
  cursor: pointer;
  .picture {
    width: 84px;
    height: 84px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dedfe1;
    border-radius: 4px;
    // overflow: hidden;
    position: relative;
    flex: none;
    background-size: cover;
    background-position: 50% 50%;
    .tip {
      width: 206px;
      height: 81px;
      position: absolute;
      left: -2px;
      top: 100%;
      margin-top: 12px;
      z-index: 9;
      img {
        min-width: auto;
        min-height: auto;
        width: 100%;
        height: 100%;
      }
      .tip-close {
        width: 16px;
        height: 16px;
        cursor: pointer;
        position: absolute;
        top: 20px;
        right: 12px;
      }
    }
    img {
      // width: 100%;
      // height: 100%;
      // max-width: 100%;
      // max-height: 100%;
      // min-width: 84px;
      // min-height: 84px;
      // border-radius: 4px;
    }
    .img2 {
      width: 40px;
      height: auto;
      display: block;
    }
  }
  .info {
    width: calc(100% - 84px);
    padding-left: 24px;
    box-sizing: border-box;
    height: 84px;
    .info-name {
      color: #9C9C9C;
      font-size: 14px;
      margin-top: 2px;
      line-height: 16px;
    }
    .info-type {
      font-size: 16px;
      color: #404040;
      margin-top: 20px;
    }
    .info-date {
      font-size: 14px;
      color: #9C9C9C;
      margin-top: 14px;
    }
  }
  .btn {
    position: absolute;
    bottom: 25px;
    right: 32px;
    display: flex;
    button {
      width: 100px;
      height: 32px;
      border-radius: 16px;
      background: #FF4F4C;
      color: #fff;
      font-size: 14px;
      display: block;
      &:last-child {
        margin-left: 14px;
      }
    }
  }
}
</style>
